import { getUserId } from '../../utils/general';
import { B2B_ACCOUNT_PATH } from './account';
import { myAccountClient as client } from './axios-client';
import { ERECEIPTS, MARKETING_PREF } from '../constants';

let userId = getUserId();

export function updateEReceiptPreferences(emailAddress, status, marketingStatus, flag, callback, err) {
  const url = `${B2B_ACCOUNT_PATH}/${userId}/profile/preferences`;
  const request = {
    profilePreference: {
      emails: [{
        emailAddress,
        primaryFlag: flag,
        preferences: {
          preference: [
            {
              code: ERECEIPTS,
              isSubscribed: status
            },
            {
              code: MARKETING_PREF,
              isSubscribed: marketingStatus
            }]
        },
        preferenceType: 'EMAIL',
      }],
      level: 'user',
    }
  };
  client.post(url, request)
    .then(callback)
    .catch(err);

}
